module.exports = require("@nextcloud/l10n");